export const freezeFilterItemsDetails = {
    "responseId": "1716275026253-407289",
    "responseCode": "0",
    "responseMessage": "Success",
    "displayResponseMessage": "Success",
    "result": [
        {
            "keyValue": "COMPANY_NAME",
            "displayName": "Name",
            "paramName": "companyName"
        },
        {
            "keyValue": "COMPANY_CODE",
            "displayName": "Code",
            "paramName": "companyCode"
        },
        {
            "keyValue": "VENDOR_CODE",
            "displayName": "Vendor",
            "paramName": "vendorCode"
        },
    ]
}

export const debitCreditFilterItemsDetails = {
    "responseId": "1716275026253-407289",
    "responseCode": "0",
    "responseMessage": "Success",
    "displayResponseMessage": "Success",
    "result": [
        {
            "keyValue": "COMPANY_NAME",
            "displayName": "Name",
            "paramName": "companyName"
        },
        {
            "keyValue": "COMPANY_CODE",
            "displayName": "Code",
            "paramName": "companyCode"
        },
        {
            "keyValue": "VENDOR_CODE",
            "displayName": "Vendor",
            "paramName": "vendorCode"
        },
    ]
}

export const addCompanyFilterItems = {
    "responseId": "1716275026253-407289",
    "responseCode": "0",
    "responseMessage": "Success",
    "displayResponseMessage": "Success",
    "result": [
        {
            "keyValue": "COMPANY_NAME",
            "displayName": "Name",
            "paramName": "companyName"
        },
        {
            "keyValue": "COMPANY_CODE",
            "displayName": "Code",
            "paramName": "companyCode"
        },
        // {
        //     "keyValue": "COMPANY_ID",
        //     "displayName": "Company Id",
        //     "paramName": "companyId"
        // },
    ]
}
export const exclusionFilterItemsDetails = {
    "responseId": "1716275026253-407289",
    "responseCode": "0",
    "responseMessage": "Success",
    "displayResponseMessage": "Success",
    "result": [
        {
            "keyValue": "BILLING_ACCOUNT_NO",
            "displayName": "Billing Account No",
            "paramName": "billingAccountNo"
        },
        // {
        //     "keyValue": "COMPANY_CODE",
        //     "displayName": "Code",
        //     "paramName": "companyCode"
        // },
        {
            "keyValue": "REPORT_DATE",
            "displayName": "Report Date",
            "paramName": "reportDate"
        },
        {
            "keyValue": "TRANSACTION_TYPE",
            "displayName": "Transaction Type",
            "paramName": "transactionType"
        }
    ]
}